// extracted by mini-css-extract-plugin
export default {"call":"styles_call__Mbidt","loading":"styles_loading__S9X1i"};